module.exports = __webpack_public_path__ + "img/fortchain_token.a143bff2.png";